export default function isValidEMail(email) {
  return /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u00E0-\u00FC.!#$%&'*+-/=?^_`{|}~\-\d]+)@(?!\.)([a-zA-Z0-9\u00E0-\u00FC\-\\.\d]+)((\.([a-zA-Z]){2,63})+)$/i.test(String(email))
}